export const ACL_SESSION_STORAGE = {
  ACL_GUARD: "ACL_GUARD",
  ACL_GUARD_DIRTY_STATUS_PREFIX: "ACL_DIRTY_STATUS",
  IS_ACL_ENABLED: "IS_ACL_ENABLED",
  IS_ROUTE_GUARD: "IS_ROUTE_GUARD",
};
export const IS_ACL_ENABLED = {
  Y: "Y",
  N: "N",
};
export const IS_ROUTE_ENABLED = {
  Y: "Y",
  N: "N",
};
export const ACL_DIRTY_STATUS = {
  Y: "Y",
  N: "N",
  OFF: "OFF",
};
